<template>
	<div>
		<h3 style="">兑换权益</h3>
		<el-button type="primary" @click="detail()">新建兑换权益</el-button>
		<el-table :data="tableData"
			:header-cell-style="{'text-align':'center','background-color':'#ebebeb','color':'#333333','font-size':'18px'}"
			:cell-style="{'text-align':'center','font-size':'16px'}">
			<el-table-column prop="name" label="活动名称"></el-table-column>
			<el-table-column label="兑换的权益">
				<template slot-scope="scope">
					{{scope.row.type | typeFilter}}
				</template>
			</el-table-column>
			<el-table-column prop="getNum" label="已领取数"></el-table-column>
			<el-table-column prop="total" label="总数"></el-table-column>
			<el-table-column prop="endTime" label="有效期">
				<template slot-scope="scope">
					{{scope.row.expiredType == true?"领取"+scope.row.day+"天后到期":scope.row.endTime}}
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button type="text" @click="detail(scope.row.id)">编辑</el-button>
					<el-button type="text" @click="listCodes(scope.row)">兑换记录</el-button>
					<!-- <el-button type="text" style="color: red;">删除</el-button> -->
				</template>
			</el-table-column>
		</el-table>
		<el-dialog :visible.sync="dialog" :title="name">
			<el-table :data="codeData">
				<el-table-column prop="code" label="兑换码"></el-table-column>
				<el-table-column label="头像/昵称/手机号">
					<template slot-scope="scope">
						<el-image :src="scope.row.user ==null?'':scope.row.user.avatarUrl"
							style="width: 50px;height: 50px;">
							<div slot="error" class="image-slot">
								<i class="el-icon-picture-outline" style="width: 50px;height: 50px;"></i>
							</div>
						</el-image>
					</template>
				</el-table-column>
				<el-table-column label="昵称">
					<template slot-scope="scope">
						{{scope.row.user ==null?'暂无':scope.row.user.nickName}}
					</template>
				</el-table-column>
				<el-table-column label="手机号">
					<template slot-scope="scope">
						{{scope.row.user ==null?'暂无':scope.row.user.telphone}}
					</template>
				</el-table-column>
				<!-- 				<el-table-column label="状态">
					<template slot-scope="scope">
					</template>
				</el-table-column> -->
			</el-table>
			<div style="text-align: center;">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="query.page" :page-sizes="[10, 20, 30, 50]" :page-size="10"
					layout="total,sizes, prev, pager, next, jumper" :total="query.total">
				</el-pagination>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	let that;
	export default {
		data() {
			return {
				tableData: [{
					id: 0,
					name: '1',
					addTime: '2021-10',
					content: '1'
				}, ],
				typeList: [{
					value: 0,
					label: '19.9会员'
				}, {
					value: 1,
					label: '99澳宝'
				}, {
					value: 2,
					label: '148澳宝'
				}, ],
				name: '',
				codeData: [],
				dialog: false,
				query: {
					page: 0,
					size: 10,
					total: 0,
				}
			}
		},
		beforeCreate() {
			that = this;
		},
		mounted() {
			this.getList();
		},
		filters: {
			typeFilter(val) {
				var label = ''
				that.typeList.forEach(item => {
					if (item.value == val) {
						label = item.label
					}
				})
				return label
			},
			nu(val) {
				if (val == null || val == '' || val == 'null' || val == undefined) {
					return "暂无"
				} else {
					return val;
				}
			},
			statusFilter(val) {}
		},
		methods: {
			getList() {
				this.$http.get("dExchange/listPlan").then(res => {
					this.tableData = res.body.data
				})
			},
			detail(id) {
				this.$router.push({
					path: "/exchangeDetail",
					query: {
						id: id
					}
				})
			},
			listCodes(row) {
				// parseInt(this.query.page + 1)
				var a = '?id='
				if (row.id) {
					a += row.id + '&pageNum=' + this.query.page + '&pageSize=' + this.query.size
				}
				this.$http.get("dExchange/listCodes" + a).then(res => {
					this.codeData = res.body.data
					this.name = row.name + '的兑换记录'
					this.query.total = res.body.total
					this.dialog = true
				})
			},
			handleSizeChange(val) {
				this.query.size = val
				this.listCodes()
			},
			handleCurrentChange() {
				this.query.page = val
				this.listCodes()
			}
		}
	}
</script>

<style>
	.flex {
		display: flex;
	}

	.image-slot {
		width: 50px;
		height: 50px;
	}
</style>